import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class ContributionStatistics extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    totalContributionsDataKey: null,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    const totalContributionsDataKey = contract.methods["totalContributions"].cacheCall();
    
    this.setState({ totalContributionsDataKey: totalContributionsDataKey });
  }
  
  render() {
    const { activeAccount } = this.context;

    // destructure drizzle and drizzleState from props
    if(activeAccount == null) {//remove this
      return (
        <div>Account not connected, please connect your wallet to add yourself to whitelist<br/>
          <button onClick={this.context.connect}>
            Connect Wallet
          </button>
        </div>
      );
    }
    
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var totalContributionsContract = GAMEFORESTSale["totalContributions"][this.state.totalContributionsDataKey];
    
    if(totalContributionsContract == undefined) {
      return <div>Loading...</div>;
    }

    var totalContribution = totalContributionsContract.value;
    if(totalContribution == null) {
      return <div>Loading...</div>;
    }
    totalContribution = this.context.web3.utils.fromWei(totalContribution.toString(), "ether")

    return (
      <div>
        {totalContribution}
      </div>
      
    );
  }
};

export default ContributionStatistics;
